var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "仓库" },
                                        model: {
                                          value: _vm.form.origin,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "origin", $$v)
                                          },
                                          expression: "form.origin"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.storehouseIds, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "快递公司" },
                                        model: {
                                          value: _vm.form.shipping_company,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "shipping_company",
                                              $$v
                                            )
                                          },
                                          expression: "form.shipping_company"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.shipping_company,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item,
                                              attrs: {
                                                label: item,
                                                value: item
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "类型" },
                                        model: {
                                          value: _vm.form.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "type", $$v)
                                          },
                                          expression: "form.type"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.pici_type,
                                          function(item, index) {
                                            return item != ""
                                              ? _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item,
                                                    value: index
                                                  }
                                                })
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.pici_status,
                                          function(item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item,
                                                value: index
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "500px" },
                                    attrs: { label: "提交时间：" }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "500px" },
                                    attrs: { label: "审核时间：" }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.check_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "check_time", $$v)
                                        },
                                        expression: "form.check_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c("div", [_vm._v("数据列表：")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "auto" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.output }
                        },
                        [_vm._v("导出")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                height: "600",
                                data: _vm.resData.list,
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cod_pici_no",
                                  label: "审核批次",
                                  width: "120",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cod_pici_origin",
                                  label: "仓库",
                                  width: "120",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_admin_name",
                                  label: "提交人",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "提交时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "remark",
                                  label: "提交说明",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_company",
                                  label: "快递公司",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "num",
                                  label: "包裹数量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_num",
                                  label: "商品件数",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cod_pici_type",
                                  label: "类型",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "money",
                                  label: "应收货款",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cod_pici_status",
                                  label: "状态",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "check_admin_name",
                                  label: "审核人",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "check_time",
                                  label: "审核时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "money_time",
                                  label: "收款日期",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "check_reason",
                                  label: "审核理由",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "right",
                                  label: "操作",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.status == 1
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.checkVisible = true
                                                      _vm.check_id =
                                                        scope.row.cod_pici_id
                                                    }
                                                  }
                                                },
                                                [_vm._v("审核")]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3792327085
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.curPage,
                              background: "",
                              layout: "total, prev, pager, next, jumper ,sizes",
                              total: _vm.resData.count,
                              "page-size": _vm.form.pagesize,
                              "page-sizes": [50, 100, 200, 500, 1000]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.curPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.curPage = $event
                              },
                              "current-change": _vm.handleCurrentChange,
                              "size-change": _vm.handleSizeChange
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "类型",
                        visible: _vm.checkVisible,
                        width: "380"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.checkVisible = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-form",
                        { staticStyle: { "margin-left": "10%" } },
                        [
                          _c(
                            "el-form-item",
                            [
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: "2" },
                                    model: {
                                      value: _vm.check_status,
                                      callback: function($$v) {
                                        _vm.check_status = $$v
                                      },
                                      expression: "check_status"
                                    }
                                  },
                                  [_vm._v("通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: "3" },
                                    model: {
                                      value: _vm.check_status,
                                      callback: function($$v) {
                                        _vm.check_status = $$v
                                      },
                                      expression: "check_status"
                                    }
                                  },
                                  [_vm._v("驳回")]
                                )
                              ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "500px" },
                              attrs: { label: "收款时间：" }
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.money_time,
                                  callback: function($$v) {
                                    _vm.money_time = $$v
                                  },
                                  expression: "money_time"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "审核理由" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "审核理由"
                                },
                                model: {
                                  value: _vm.check_reason,
                                  callback: function($$v) {
                                    _vm.check_reason = $$v
                                  },
                                  expression: "check_reason"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.checkVisible = false
                                    }
                                  }
                                },
                                [_vm._v("取 消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.check }
                                },
                                [_vm._v("确 定")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb80aca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb80aca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cod/checkList.vue
// module id = null
// module chunks = 